export default "__VITE_ASSET__56Q9h852__"